import {
  MAX_COVER_TILL_AGE_PLUS,
  MIN_POLICY_TERM_YEARS,
  PLAN_NAMES_NISCHIT_PENSION,
} from "../../constants";

/**
 * Lead / quote-init APIs may return a single number or a one-element array.
 * @param {number|number[]|null|undefined} value
 * @returns {number|null}
 */
export function normalizeLeadNumericOption(value) {
  if (value == null) return null;
  const n = Number(Array.isArray(value) ? value[0] : value);
  return Number.isFinite(n) ? n : null;
}

/** Matches ProductEligibilityUtil.capPlusMaxCoverTillAge */
export function capPlusMaxCoverTillAge(leadMaxCoverTillAge) {
  const raw = normalizeLeadNumericOption(leadMaxCoverTillAge);
  if (raw == null) return null;
  return Math.min(raw, MAX_COVER_TILL_AGE_PLUS);
}

/** Matches ProductEligibilityUtil.capPlusMaxPolicyTerm */
export function capPlusMaxPolicyTerm(leadMaxPolicyTerm, attainedAgeYears) {
  const raw = normalizeLeadNumericOption(leadMaxPolicyTerm);
  if (raw == null) return null;
  if (attainedAgeYears == null || Number.isNaN(Number(attainedAgeYears))) {
    return raw;
  }
  const byCoverTillAgeCap = MAX_COVER_TILL_AGE_PLUS - Number(attainedAgeYears);
  if (byCoverTillAgeCap < MIN_POLICY_TERM_YEARS) {
    return null;
  }
  return Math.min(raw, byCoverTillAgeCap);
}

/**
 * Max cover-till age shown on quote (Plus capped at 75; Elite uses lead max).
 */
export function effectiveMaxCoverTillAgeForPlan(leadCoverTillOptions, plan) {
  const raw = normalizeLeadNumericOption(leadCoverTillOptions);
  if (raw == null) return null;
  return plan === PLAN_NAMES_NISCHIT_PENSION.PLAN_A ? capPlusMaxCoverTillAge(raw) : raw;
}

/**
 * Max policy term for stepped options / bulk grid (Plus capped by cover-till-age rule).
 */
export function effectiveMaxPolicyTermForPlan(
  leadPolicyTermOptions,
  plan,
  attainedAgeYears,
) {
  const raw = normalizeLeadNumericOption(leadPolicyTermOptions);
  if (raw == null) return null;
  if (plan !== PLAN_NAMES_NISCHIT_PENSION.PLAN_A) return raw;
  const capped = capPlusMaxPolicyTerm(raw, attainedAgeYears);
  return capped != null ? capped : raw;
}
